module.exports = __webpack_public_path__ + "img/394.57c87ac1.jpg";